import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import { useEffect, useState } from "react";
import MDButton from 'components/MDButton';
import MDInput from "components/MDInput";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
// import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { Oval } from 'react-loader-spinner';
import Select from "react-select";
import * as service from '../../../services/service';

function CaseStages() {
    const [state, setState] = useState({
        casestage: '', sequence: ''
    });
    const [data, setData] = useState([]);
    const [courtData, setCourtData] = useState([]);
    const [courtId, setCourtId] = useState('');
    const [caseTypeData, setCaseTypeData] = useState([]);
    const [caseTypeId, setCaseTypeId] = useState('');
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const selectStyles = { menu: styles => ({ ...styles, zIndex: 999 }) };

    const getCourts = () => {
        fetch(
            service.COURTS_URL,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
            })
            .then(res => res.json())
            .then(result => {
                const data2 = result.map((item) => ({ value: item.courtId, label: item.court }));
                setCourtData(data2);
            });
    };

    const getCaseTypes = (id) => {
        fetch(
            service.GET_CASE_TYPE_BY_COURT_ID,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    CourtId: id
                })
            })
            .then(res => res.json())
            .then(result => {
                const data2 = result.map((item) => ({ value: item.caseTypeId, label: item.caseType }));
                setCaseTypeData(data2);
            });
    };

    const getDetails = (id) => {
        const errs = {};
        fetch(
            service.GET_CASE_STAGE_BY_TYPE_ID,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    CaseTypeId: id
                })
            })
            .then(res => res.json())
            .then(result => {
                setData(result);
            })
            .catch(err => {
                if (err) {
                    errs[".invalid"] = err;
                    setErrors(err);
                };
            });
    };

    const getDetailsById = (id) => {
        setLoading(true);
        const errs = {};
        fetch(
            service.GET_CASE_STAGE_BY_ID,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    CaseStageId: id,
                })
            })
            .then(res => res.json())
            .then(result => {
                if (result.message.messageType === 'Success') {
                    setState({
                        ...state, casestage: result.caseStage, sequence: result.sequence
                    });

                    const crData = ({ value: result.courtId, label: result.court });
                    setCourtId(crData);
                    getCaseTypes(crData.value);
                    const ctData = ({ value: result.caseTypeId, label: result.caseType });
                    setCaseTypeId(ctData);
                }
                else {
                    errs[".invalid"] = result.message.message;
                    setErrors(errs);
                }
            });
        setLoading(false);
    };
    const handleEdit = (id) => {
        getDetailsById(id);
        localStorage.setItem("ID", JSON.stringify(id));
    }

    useEffect(() => {
        setLoading(true);
        getCourts();
        setLoading(false);
    }, []);

    const validate = () => {
        let isValid = true;
        const errs = {};
        if (!state.casestage) {
            isValid = false;
            errs[".casestage"] = "Please enter case stage";
        }
        if (!courtId) {
            isValid = false;
            errs[".courtId"] = "Please select court";
        }
        if (!caseTypeId) {
            isValid = false;
            errs[".caseTypeId"] = "Please select case type";
        }
        if (!state.sequence) {
            isValid = false;
            errs[".sequence"] = "Please enter sequence";
        }
        setErrors(errs);
        return isValid;
    }

    const changeHandler = (event) => {
        setState({ ...state, [event.target.name]: event.target.value });
    };

    const CourtChangeHandler = (ev) => {
        setCourtId(ev);
        getCaseTypes(ev.value);
    }
    const CaseTypeChangeHandler = (ev) => {
        setCaseTypeId(ev);
        getDetails(ev.value);
    }

    const clearHandler = () => {
        localStorage.setItem('ID', null);
        setState({
            ...state, casestage: '', sequence: ''
        });
        const cr = ({ value: null, label: "Select Court" });
        setCourtId(cr);
        const ct = ({ value: null, label: "Select Case Type" });
        setCaseTypeId(ct);
        setData([]);
    }

    const submitHandler = e => {
        e.preventDefault();
        const errs = {};
        setLoading(true);
        if (validate()) {
            fetch(
                service.ADD_UPDATE_CASE_STAGE,
                {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        CaseStageId: JSON.parse(localStorage.getItem('ID')) !== null ? JSON.parse(localStorage.getItem('ID')) : 0,
                        CaseStage: state.casestage,
                        CaseTypeId: caseTypeId.value,
                        Sequence: state.sequence,
                        AddedBy: JSON.parse(sessionStorage.getItem('userData')).userId,
                        UpdatedBy: JSON.parse(sessionStorage.getItem('userData')).userId,
                    })
                })
                .then(res => res.json())
                .then(result => {
                    if (result.messageType === 'Success') {
                        // eslint-disable-next-line
                        alert(result.message);
                        localStorage.setItem('ID', null);
                        // window.location.reload();
                        setState({ ...state, casestage: '' });
                        getDetails(caseTypeId.value);
                    }
                    else if (result.messageType === 'Failed') {
                        // eslint-disable-next-line
                        alert(result.message);
                    }
                    else {
                        errs[".invalid"] = result.message;
                        setErrors(errs);
                    }
                });
        }
        setLoading(false);
    }
    return (
        <DashboardLayout>
            <DashboardNavbar />
            <MDBox pt={6} pb={3}>
                <Grid container spacing={6}>
                    <Grid item xs={12}>
                        <Card>
                            <MDBox
                                mx={2}
                                mt={-3}
                                py={3}
                                px={2}
                                variant="gradient"
                                bgColor="info"
                                borderRadius="lg"
                                coloredShadow="info"
                            >
                                <MDTypography variant="h6" color="white">
                                    Case Stage Details
                                </MDTypography>
                            </MDBox>
                            <br />
                            <Card style={{ alignItems: 'center' }}>
                                <Table style={{ alignItems: 'center', width: "50%" }}>
                                    <TableBody>
                                        <TableRow>
                                            <TableCell width="45%">
                                                <Select
                                                    name="Court"
                                                    options={courtData} placeholder="Select Court"
                                                    value={courtId}
                                                    onChange={CourtChangeHandler}
                                                    isSearchable
                                                    styles={selectStyles}
                                                />
                                                <div style={{ fontSize: '12px', color: 'red' }}>{errors[".courtId"]}</div>
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell width="45%">
                                                <Select
                                                    name="Case Type"
                                                    options={caseTypeData} placeholder="Select Case Type"
                                                    value={caseTypeId}
                                                    onChange={CaseTypeChangeHandler}
                                                    isSearchable
                                                    styles={selectStyles}
                                                />
                                                <div style={{ fontSize: '12px', color: 'red' }}>{errors[".caseTypeId"]}</div>
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>
                                                <MDInput label="Case Stage" fullWidth value={state.casestage || ''}
                                                    name="casestage"
                                                    onChange={changeHandler}
                                                    id="casestage"
                                                    required />
                                                <div style={{ fontSize: '12px', color: 'red' }}>{errors[".casestage"]}</div>
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>
                                                <MDInput label="Sequence" fullWidth value={state.sequence || ''}
                                                    name="sequence"
                                                    onChange={changeHandler}
                                                    id="sequence"
                                                    required />
                                                <div style={{ fontSize: '12px', color: 'red' }}>{errors[".sequence"]}</div>
                                            </TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                                <MDBox mt={4} mb={1} textAlign="center">
                                    {loading ? <Oval
                                        heigth="20"
                                        width="20"
                                        color='grey'
                                        ariaLabel='loading'
                                    /> :
                                        <div>
                                            <MDButton color="info" onClick={submitHandler}>
                                                SAVE
                                            </MDButton>&nbsp;&nbsp;&nbsp;&nbsp;
                                            <MDButton color="info" onClick={clearHandler}>
                                                CLEAR
                                            </MDButton>
                                        </div>
                                    }
                                    {errors ? <div style={{ fontSize: '12px', color: 'red' }}>{errors[".invalid"]}</div> : null}
                                </MDBox>

                            </Card>
                            <br />
                            <Card style={{ alignItems: 'center' }}>
                                {loading ? <Oval
                                    heigth="100"
                                    width="100"
                                    color='grey'
                                    ariaLabel='loading'
                                /> :
                                    <TableContainer component={Paper} style={{ width: '95%', alignSelf: 'center', }}>
                                        <Table aria-label="simple table">

                                            <TableRow style={{ backgroundColor: 'lightgrey' }}>
                                                <TableCell style={{ fontWeight: 'bold' }}>Court</TableCell>
                                                <TableCell style={{ fontWeight: 'bold' }}>Case Type</TableCell>
                                                <TableCell style={{ fontWeight: 'bold' }}>Case Stage</TableCell>
                                                <TableCell style={{ fontWeight: 'bold' }}>Sequence</TableCell>
                                                <TableCell style={{ fontWeight: 'bold' }}>Action</TableCell>
                                            </TableRow>

                                            <TableBody>
                                                {data.map((row) => (
                                                    <TableRow
                                                        key={row.caseStageId}
                                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                                    >
                                                        <TableCell>{row.court}</TableCell>
                                                        <TableCell>{row.caseType}</TableCell>
                                                        <TableCell>{row.caseStage}</TableCell>
                                                        <TableCell>{row.sequence}</TableCell>
                                                        <TableCell><MDButton onClick={() => handleEdit(row.caseStageId)}>Edit</MDButton></TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>

                                }
                            </Card>
                        </Card>
                    </Grid>
                </Grid>
            </MDBox>
            <div style={{ position: 'absolute', left: 0, right: 0, bottom: 0 }}>
                <Footer />
            </div>
        </DashboardLayout>
    );
}
export default CaseStages;